import { AccountData, HolidayCalendar } from '../api';

const usesUsConventions = (account?: AccountData): boolean => account?.holiday_calendar === HolidayCalendar.US;

export const getDateFormat = (account?: AccountData) => {
  const us = usesUsConventions(account);
  return {
    shortDateFormat: us ? 'MM/DD' : 'DD/MM',
    longDateFormat: us ? 'MM/DD/YYYY' : 'DD/MM/YYYY',
    cardDateFormat: us ? 'dddd, MMMM D' : 'dddd, D MMMM',
  };
};

export const getTimeFormat = (account?: AccountData): string => (usesUsConventions(account) ? 'h:mm A' : 'HH:mm');
